<template>
    <div class="index-nav-wrap">
        <div class="header-return">
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                <el-button type="success" size="mini" @click="handleEdit('')">新增</el-button>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleTabClick" type="border-card">
            <template v-for="item in tabList">
                <el-tab-pane :label="item.name" :name="item.id">
<!--                    <el-row>
                        <el-col :span="12">
                            <el-switch @change="handleShowNav"
                                v-model="showNav"
                                active-text="显示导航"
                                inactive-text="不显示导航"
                                active-value=1
                                inactive-value=0>
                            </el-switch>
                        </el-col>
                        <el-col :span="12">
                            <el-switch @change="handleShowNavIcon"
                                    v-model="showNavIcon"
                                    active-text="显示导航图片"
                                    inactive-text="不显示导航图片"
                                    active-value=1
                                    inactive-value=0
                                    :disabled="iconDisabled">
                            </el-switch>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>-->
                    <el-table :data="sectionList" stripe border center :size="GCONFIG.styleTableSize">
                        <el-table-column prop="navSn" label="排序号"></el-table-column>
                        <el-table-column prop="navSn" label="栏目等级">
                            <template slot-scope="scope">
                                <el-tag v-if="scope.row.hasChild" type="info" effect="dark" size="mini">一级</el-tag>
                                <el-tag v-if="!scope.row.hasChild" type="info" effect="plain" size="mini">二级</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="indexNavId" label="栏目id"></el-table-column>
                        <el-table-column prop="navName" label="导航名称"></el-table-column>
                        <el-table-column prop="navName1" label="主标题"></el-table-column>
                        <el-table-column prop="navName2" label="副标题"></el-table-column>
                        <el-table-column prop="navName3" label="标识" ></el-table-column>
                        <el-table-column prop="isShow" label="是否启用" :formatter="isShowProccess"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="230">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button type="primary" v-show="!scope.row.hasChild&&scope.row.navType==1" size="mini" @click="handleItem(scope.row)">配置商品</el-button>
                                    <el-button type="success"  size="mini" @click="handleEdit(scope.row.indexNavId)">修改</el-button>
                                    <el-button type="danger " size="mini" @click="handleDel(scope.row.indexNavId)">删除</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </template>
        </el-tabs>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center @close="resetInfoForm">
            <el-form :model="form" label-width="80px" ref="editForm">
                <el-form-item label="平台">
                    <el-select v-model="form.platformId" clearable  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in tabList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="parseInt(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="父级导航">
                    <el-select v-model="form.parentIndexNavId" clearable  placeholder="父级导航" >
                        <el-option v-for="item in sectionList"
                                   :key="item.indexNavId"
                                   :label="item.navName"
                                   :value="item.indexNavId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="导航名称">
                    <el-input v-model="form.navName" clearable  placeholder="导航名称"></el-input>
                </el-form-item>
                <el-form-item label="导航名称1">
                    <el-input v-model="form.navName1" clearable  placeholder="导航名称1"></el-input>
                </el-form-item>
                <el-form-item label="导航名称2">
                    <el-input v-model="form.navName2" clearable  placeholder="导航名称2"></el-input>
                </el-form-item>
                <el-form-item label="导航名称3">
                    <el-input v-model="form.navName3" clearable  placeholder="导航名称3"></el-input>
                </el-form-item>
                <el-form-item label="排序号">
                    <el-input-number v-model="form.navSn"  :min="0" :max="10000" label="排序号"></el-input-number>
                </el-form-item>
                <el-form-item label="ICON图">
                    <uploadComponents :fromState="'onlyOne'" v-model="form.navIcon" :urlType="2" @selectPicOne="selectPicOne"></uploadComponents>
                </el-form-item>
                <el-form-item label="倒计时" v-show="false">
                    <el-select v-model="form.countdown" clearable  placeholder="倒计时">
                        <el-option v-for="item in countdownData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="栏目类型">
                    <el-select v-model="form.navType" clearable  placeholder="栏目类型">
                        <el-option v-for="item in indexNavTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否启用">
                    <el-select v-model="form.isShow" clearable  placeholder="是否启用">
                        <el-option v-for="item in isShowData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="栏目模板">
                    <el-select v-model="form.navBuildPageId" clearable  placeholder="栏目模板">
                        <el-option v-for="item in navBuildPageData"
                                   :key="item.buildPageId"
                                   :label="item.pageName"
                                   :value="item.buildPageId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="板块模板">
                    <el-select v-model="form.buildPageId" clearable  placeholder="板块模板">
                        <el-option v-for="item in buildPageData"
                                   :key="item.buildPageId"
                                   :label="item.pageName"
                                   :value="item.buildPageId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="save(form)">确 定</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getIndexNavList,getIndexNavTree,getValidDictionaryList,getPlatformList,getIndexNav,saveIndexNav,deleteIndexNav,getIndexNavTypeList,
        getBuildPageList,buildModulePage,getShowNavAndIcon,showNav,showNavIcon} from '../../api/api'
    import uploadComponents from '@/components/upload';
    //定义组件
    export default{
        data(){
            return {
                getIndexNavList:[],
                countdownData:[{"id":0,"name":"不显示"},{"id":1,"name":"整体倒计时"},{"id":2,"name":"分别显示"}],
                isShowData:[{"id":0,"name":"禁用"},{"id":1,"name":"启用"}],
                platformData:[],
                navBuildPageData:[],
                buildPageData:[],
                loading:true,
                indexNavTypeList:[],
                platformId:0,
                selectValue: 0,
                dialogFormVisible:false,
                form:{
                    "navName":"",
                    "navName1":"",
                    "navName2":"",
                    "navName3":"",
                    "platformId":'',
                    "navSn":0,
                    "navIcon":"",
                    "countdown":1,
                    "isShow":0,
                    "navBuildPageId":"",
                    "buildPageId":"",
                    "indexNavId":"",
                    "parentIndexNavId":"",
                    "navType":1
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                formInline:{
                    "job_name":"",
                    "job_group":"",
                },
                platformDisabled:false,
                activeName:'1',
                showNav:0,
                showNavIcon:0,
                iconDisabled:false
            }
        },
        computed:{
            tabList(){
                return this.$store.getters.getIndexNavTabList
            },
            sectionList(){
                return this.$store.getters.getIndexSectionList
            }
        },
        //挂载时候执行
        mounted(){
            let _this = this;
            this.$store.dispatch('initIndexNavTabList').then((res1) => {
                if(res1.id == '1002'){
                    _this.activeName = '21'
                }else{
                    _this.activeName = '4'
                }
                _this.$store.dispatch('initIndexSectionList',{platformId:_this.activeName});
                this.$store.dispatch('initIndexBuildMoList',{platformId:_this.activeName,navType:1}).then((res) => {
                    if(res.data.status == 200){
                        _this.navBuildPageData = res.data.value;
                    }
                });
                this.$store.dispatch('initIndexBuildMoList',{platformId:_this.activeName,navType:2}).then((res) => {
                    if(res.data.status == 200){
                        _this.buildPageData = res.data.value;
                    }
                });
            });
            this.showNavAndIcon();
            this.getIndexNavTypeListData();
        },
        components:{
            uploadComponents
        },
        methods:{
            filterIsShow(value, row) {
                console.log(row);
                return row.isShow == value;
            },
            filterCountDown(value,row){
                return row.countdown == value;
            },
            handleDel(id){
                let _this = this;
                this.$confirm('确定删除选中的行吗？','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteIndexNav({indexNavId: id}).then((res) => {
                        if (res.data.status == 200) {
                            _this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            _this.$store.dispatch('initIndexSectionList',{platformId:_this.activeName});
                        } else {
                            _this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }).catch(() => {
                    _this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleTabClick(){
                this.$store.dispatch('initIndexSectionList',{platformId:this.activeName});
                this.showNavAndIcon();
            },
            getIndexNavTypeListData(){
                getIndexNavTypeList().then((res) => {
                    if (res.data.status == 200) {
                        this.indexNavTypeList=res.data.value;
                        for (let i = 0; i < this.indexNavTypeList.length; i++) {
                            this.indexNavTypeList[i].id=parseInt(this.indexNavTypeList[i].id);
                        }
                    }
                });
            },
            handleEdit(id){
                let _this = this;
                this.dialogFormVisible = true;
                if(id!=''){
                    getIndexNav({indexNavId:id}).then((res) => {
                        console.log(res);
                        _this.form = res.data.index;
                        _this.platformDisabled=true;
                    });
                }else{
                    _this.platformDisabled=false;
                }
            },
            save(data){
                let _this = this;
                if(data.platformId==""){
                    this.$message({
                        message:"平台必选",
                        type:'error'
                    });
                    return ;
                }
                if(data.navName==""){
                    this.$message({
                        message:"导航名称必填",
                        type:'error'
                    });
                    return ;
                }

                if(data.pageType==""){
                    this.$message({
                        message:"页面类型必选",
                        type:'error'
                    });
                    return ;
                }
                if(data.navType==""){
                    this.$message({
                        message:"栏目类型必选",
                        type:'error'
                    });
                    return ;
                }
                if(data.navBuildPageId==""||data.navBuildPageId=="0"){
                    this.$message({
                        message:"栏目模板必选",
                        type:'error'
                    });
                    return ;
                }
                if(data.buildPageId==""||data.buildPageId=="0"){
                    this.$message({
                        message:"板块模板必选",
                        type:'error'
                    });
                    return ;
                }
                saveIndexNav(data).then((res) => {
                    console.log(res);
                    if(res.data.success){
                        _this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        _this.dialogFormVisible=false;
                        _this.$store.dispatch('initIndexSectionList',{platformId:_this.activeName});
                    }else{
                        _this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });

            },
            handleItem(data){
                this.$router.push({path:'/indexNavList/:indexNavId',name: 'IndexItemList',params:{indexNavId:data.indexNavId}})
            },
            isShowProccess(row, column, cellValue){
                for(var key in this.isShowData){
                    if(this.isShowData[key].id==cellValue) {
                        return this.isShowData[key].name;
                    }
                }
            },
            countdownProccess(row, column, cellValue){
                for(var key in this.countdownData){
                    if(this.countdownData[key].id==cellValue) {
                        return this.countdownData[key].name;
                    }
                }
            },
            resetInfoForm(){
                this.form = {
                    "navName":"",
                    "navName1":"",
                    "navName2":"",
                    "navName3":"",
                    "platformId":'',
                    "navSn":0,
                    "navIcon":"",
                    "countdown":1,
                    "isShow":0,
                    "navBuildPageId":"",
                    "buildPageId":"",
                    "indexNavId":""
                };
            },
            showNavAndIcon(){
                //这个方法是初始化展示开关的，在初次加载和切换tab页时都要调用
                getShowNavAndIcon({'platformId': this.activeName}).then((res) => {
                    console.log("showIcon",res);
                    this.showNav = "" + res.data.value.showNav;
                    this.showNavIcon = "" + res.data.value.showNavIcon;
                    if(this.showNav == 0){
                        this.iconDisabled = true;
                    } else {
                        this.iconDisabled = false;
                    }
                });
            },
            handleShowNav(){
                var alertText = "";
                if(this.showNav == 0){
                    alertText = "确定关闭显示导航栏吗？";
                } else if(this.showNav == 1){
                    alertText = "确定开启显示导航栏吗？";
                }
                this.$confirm(alertText,'提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    showNav({'platformId': this.activeName,'showNav': this.showNav}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            if(this.showNav == 0){
                                this.iconDisabled = true;
                            } else {
                                this.iconDisabled = false;
                            }
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                    this.showNav = (this.showNav == 0 ? "1" : "0");
                });
            },
            handleShowNavIcon(){
                var alertText = "";
                if(this.showNavIcon == 0){
                    alertText = "确定关闭显示导航栏图标吗？";
                } else if(this.showNavIcon == 1){
                    alertText = "确定开启显示导航栏图标吗？";
                }
                this.$confirm(alertText,'提示',{
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    showNavIcon({'platformId': this.activeName,'showNavIcon': this.showNavIcon}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }).catch(() => {
                    this.showNavIcon = (this.showNavIcon == 0 ? "1" : "0");
                });
            },
            returnHistory(){
                window.history.go(-1)
            },
            selectPicOne(obj){
                console.log(obj)
                this.form.navIcon = obj.allImagePath
            },
        }
    }

</script>

<style lang="scss" rel="stylesheet/scss">
    .index-nav-wrap{
        padding: 10px;
    }
    .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/views/pageconfig/indexNavList.vue